import * as React from 'react';
import { AlarmStatus } from '../../lib/alarm-helpers';
import { AcknowledgedStatusLabel } from '../AcknowledgedStatusLabel';
import { OpenStatusLabel } from '../OpenStatusLabel';
import { ClosedStatusLabel } from '../ClosedStatusLabel';
import { UnAcknowledgedStatusLabel } from '../UnAcknowledgedStatusLabel';

export const AlarmBadge: React.FC<{ alarmStatus: string }> = (props) => (
    <>
        {props.alarmStatus === AlarmStatus.Acknowledged && <AcknowledgedStatusLabel />}
        {props.alarmStatus === AlarmStatus.Open && <OpenStatusLabel />}
        {props.alarmStatus === AlarmStatus.Closed && <ClosedStatusLabel />}
        {props.alarmStatus === AlarmStatus.Cleared && <UnAcknowledgedStatusLabel />}
    </>
);
